import { useState, useEffect, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { openedFromPortal, waitForPortalTokenHandoff } from '@platzona/auth-client';
import { authService } from '../services/authService';

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const [portalWait, setPortalWait] = useState(() => openedFromPortal() && typeof window !== 'undefined' && !!window.opener);

  useEffect(() => {
    if (!portalWait) return;
    waitForPortalTokenHandoff(5000).finally(() => setPortalWait(false));
  }, [portalWait]);

  if (portalWait) {
    return (
      <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-text-muted)' }}>
        …
      </div>
    );
  }

  if (!authService.isAuthenticated()) {
    // LoginPage reads the return destination from ?next=, not router state — a
    // bare "/login" redirect lost where the user was headed, so after logging in
    // they landed on "/", which on a tenant custom domain is the public
    // storefront, not back in their (Kunde or owner) dashboard.
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
};
